import { create } from 'zustand';

export interface VoiceAssistantStoreType {
  isVoiceAssistantVisible: boolean;
  setVoiceAssistantSettings: (
    settings: Partial<VoiceAssistantStoreType>
  ) => void;
}

export const useVoiceAssistantStore = create<VoiceAssistantStoreType>(set => ({
  isVoiceAssistantVisible: false,
  setVoiceAssistantSettings: settings =>
    set(state => ({ ...state, ...settings })),
}));
